var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page", attrs: { id: "About" } },
    [
      _c("appModal", {
        ref: "appModalRef",
        attrs: { countries: _vm.DBCountries }
      }),
      _c("appHeader", {
        attrs: { bgColor: "blue", page: "about" },
        on: { headerMenuClicked: _vm.menuClicked }
      }),
      _c("div", { staticClass: "main" }, [
        _c("div", { staticClass: "main_inner" }, [
          _vm._m(0),
          _c("section", { staticClass: "main_section section_about" }, [
            _c("div", { staticClass: "section_content" }, [
              _c("div", { staticClass: "content_title" }, [_vm._v("Our Team")]),
              _c(
                "div",
                { staticClass: "content_team" },
                _vm._l(_vm.DBTeam, function(memberObj, memberIndex) {
                  return _c("div", { staticClass: "content_team_member" }, [
                    !memberObj.toggleBio
                      ? _c(
                          "div",
                          {
                            staticClass: "member_snapshot member_wrapper",
                            on: {
                              click: function($event) {
                                return _vm.showBio(memberObj)
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "member_image" }, [
                              _c("img", {
                                attrs: {
                                  src:
                                    "/images/members/" +
                                    _vm.slugifyText(memberObj.name) +
                                    ".png"
                                }
                              })
                            ]),
                            _c("div", { staticClass: "member_content" }, [
                              _c("div", { staticClass: "member_name" }, [
                                _vm._v(_vm._s(memberObj.name))
                              ]),
                              _c("div", { staticClass: "member_job" }, [
                                _vm._v(_vm._s(memberObj.job))
                              ])
                            ]),
                            _vm._m(1, true)
                          ]
                        )
                      : _c(
                          "div",
                          { staticClass: "member_bio member_wrapper" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "bio_closebt",
                                on: {
                                  click: function($event) {
                                    return _vm.hideBio()
                                  }
                                }
                              },
                              [_vm._v("Close")]
                            ),
                            _c("div", { staticClass: "bio_text" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(memberObj.bio) +
                                  "\n                                "
                              )
                            ])
                          ]
                        )
                  ])
                }),
                0
              )
            ])
          ]),
          _vm._m(2),
          _vm._m(3)
        ])
      ]),
      _c("appFooter"),
      _c("cookiesConsent")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "main_section" }, [
      _c("div", { staticClass: "section_content" }, [
        _c("h2", { staticClass: "text_subtitle" }, [_vm._v("More")]),
        _c("h1", { staticClass: "title_page text_title2" }, [
          _vm._v("\n                        About\n                    ")
        ]),
        _c(
          "p",
          { staticClass: "text_p", staticStyle: { "margin-top": "24px" } },
          [
            _vm._v(
              "\n                        The Atlas of the Offshore World is a global database aimed at informing scientific communities, civil society, and policymakers around the world about global tax avoidance. It provides detailed and accessible information about global profit shifting, offshore financial and real estate wealth, and effective tax rates worldwide, in order to facilitate and promote democratic dialogue on these topics. The Atlas of the Offshore World is produced by the "
            ),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.taxobservatory.eu/",
                  target: "_blank"
                }
              },
              [_vm._v("EU Tax Observatory")]
            ),
            _vm._v(" in collaboration with "),
            _c(
              "a",
              {
                attrs: { href: "https://www.skatteforsk.no/", target: "_blank" }
              },
              [_vm._v("Skatteforsk - Centre for Tax Research")]
            ),
            _vm._v(" and with financial support from "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://resultater.norad.no/agreement/QZA-22/0011",
                  target: "_blank"
                }
              },
              [_vm._v("Norway")]
            ),
            _vm._v(".\n                    ")
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "snapshot_hover" }, [
      _c("div", { staticClass: "hover_text" }, [
        _vm._v("Click to read description")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      { staticClass: "main_section section_about section_funders" },
      [
        _c("div", { staticClass: "section_content" }, [
          _c("div", { staticClass: "content_title" }, [_vm._v("Our Funders")]),
          _c("div", { staticClass: "content_col col_first" }, [
            _c("div", { staticClass: "partner_block small" }, [
              _c("a", {
                staticClass: "block_head",
                attrs: {
                  href: "https://resultater.norad.no/en",
                  target: "_blank"
                }
              })
            ])
          ]),
          _c("div", { staticClass: "content_col col_second" }, [
            _c("div", { staticClass: "partner_block small" }, [
              _c("a", {
                staticClass: "block_head",
                attrs: {
                  href: "https://european-union.europa.eu/index_en",
                  target: "_blank"
                }
              })
            ])
          ]),
          _c("div", { staticClass: "content_text" }, [
            _vm._v(
              "\n                        Co-funded by the European Union and Norway. Views and opinions expressed are however those of the author(s) only and do not necessarily reflect those of the European Union and Norway. Neither the European Union nor Norway can be held responsible for them.\n                    "
            )
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      { staticClass: "main_section section_about section_partners" },
      [
        _c("div", { staticClass: "section_content" }, [
          _c("div", { staticClass: "content_title" }, [_vm._v("Our Partners")]),
          _c("div", { staticClass: "content_col col_first" }, [
            _c("div", { staticClass: "partner_block small" }, [
              _c("a", {
                staticClass: "block_head",
                attrs: {
                  href: "https://www.nmbu.no/forskning/grupper/skatteforsk",
                  target: "_blank"
                }
              })
            ])
          ]),
          _c("div", { staticClass: "content_col col_second" }, [
            _c("div", { staticClass: "partner_block small" }, [
              _c("a", {
                staticClass: "block_head",
                attrs: { href: "https://www.diw.de/en", target: "_blank" }
              })
            ])
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5357e832", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5357e832","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/about/index.vue
// module id = DxZI
// module chunks = 7